// apps/web/src/components/chat/FormModal.tsx
import { MetricsForm } from './forms/MetricsForm';
import { FundForm } from './forms/FundForm';
import { CompanyImportForm } from './forms/CompanyImportForm';
import { TrialUploadForm } from './forms/TrialUploadForm';
import { TrialConfirmationForm } from './forms/TrialConfirmationForm';
import { TrialProcessingForm } from './forms/TrialProcessingForm';
import { TrialResultsForm } from './forms/TrialResultsForm';
import { InviteUserForm } from './forms/InviteUserForm';
import { UploadDocumentForm } from './forms/UploadDocumentForm';

interface FormModalProps {
  formId: string;
  data: any;
  tenantId: string;
  onSuccess: (result: any) => void;
  onClose: () => void;
}

// Form component registry
const FORM_COMPONENTS: Record<string, React.ComponentType<any>> = {
  define_metrics: MetricsForm,
  add_fund: FundForm,
  import_companies: CompanyImportForm,
  upload_trial_report: TrialUploadForm,
  trial_upload: TrialUploadForm,
  trial_confirmation: TrialConfirmationForm,
  show_trial_confirmation: TrialConfirmationForm,
  trial_processing: TrialProcessingForm,
  trial_results: TrialResultsForm,
  invite_user: InviteUserForm,
  upload_document: UploadDocumentForm,
};

export function FormModal({ formId, data, tenantId, onSuccess, onClose }: FormModalProps) {
  const FormComponent = FORM_COMPONENTS[formId];

  if (!FormComponent) {
    console.error(`Unknown form_id: ${formId}`);
    return null;
  }

  return <FormComponent data={data} tenantId={tenantId} onSuccess={onSuccess} onClose={onClose} />;
}
